import { paths } from '@/components/indication/'
import { removeItem } from '@/utils/indic'

export default {
  namespaced: true,
  state: () => ({ ...paths }),
  mutations: {
    indicationAll(state) {
      Object.keys(paths).forEach(e => {
        state[e] = true
      })
    },
    read(state, key) {
      state[key] = false
      removeItem(key)
    },
    mergeLocal(state, keys) {
      keys.forEach(e => {
        state[e] = true
      })
    }
  }
}